import { Breadcrumb, Col, Row, DatePicker, Select } from "antd";
import Title from "../UI/Title/Title";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { CustomerPaymentList } from "./ReceiptsList";
import AddButton from "../UI/AddButton/addbutton";
import ResetButton from "../UI/ResetButton/resetbutton";
import { useMutation, useQuery } from "react-query";
import { getCurrencyDropdown } from "../../api/currency";
import { getPaymentModesDropdown } from "../../api/paymentMode";
import { getCustomersDropdown } from "../../api/customers";
import { getReceipts, getSalesDropdown } from "../../api/receipts";

function CustomerPayment() {
  const { RangePicker } = DatePicker;
  const [, setSearchText] = useState("");
  const [tableKey, setTableKey] = useState(1);
  const { t } = useTranslation("common");
  const [payments, setPayments] = useState<any>([]);
  const [from, setFrom] = useState<string>("");
  const [to, setTo] = useState<string>("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [page, setPage] = useState<number>(1);
  const [formatedsales, setFormatedSales] = useState<any>([]);

  const resetFilters = () => {
    setTableKey((tableKey) => tableKey + 1);
    setSearchText("");
    setSelectedCustomer(null);
    setFrom("");
    setTo("");
  };

  const {
    mutateAsync: getCustomerPaymentsMutation,
    isLoading: isPaymentsLoading,
  } = useMutation(
    "customerPayments",
    () => getReceipts(page * 10 + 10, from, to),
    {
      onSuccess: (result) => {
        setPayments(result?.data?.data);
      },
    }
  );

  useEffect(() => {
    getCustomerPaymentsMutation();
  }, [from, getCustomerPaymentsMutation, to]);

  const navigate = useNavigate();
  const [, setInitialValues] = useState({ active: undefined });
  const [formatedCurrency, setFormatedCurrency] = useState<{}[]>();
  const { isLoading: loadingCurrency } = useQuery(
    "currencies",
    getCurrencyDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedCurrency(
          res.data
            ?.map((curr: any) => {
              if (curr.isActive) {
                return { value: curr.id, label: curr.name };
              }
              return null;
            })
            .filter((curr: any) => curr !== null)
        );
        if (res.data.length > 0) {
          setInitialValues({ active: res.data[0].id });
        }
      },
    }
  );

  const [formatedPaymentMode, setFormatedPaymentMode] = useState<{}[]>();
  const { isLoading: loadingPaymentMode } = useQuery(
    "paymentmode",
    getPaymentModesDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedPaymentMode(
          res.data
            ?.map((payment: any) => {
              if (payment.isActive) {
                return { value: payment.id, label: payment.mode };
              }
              return null;
            })
            .filter((payment: any) => payment !== null)
        );
        if (res.data.length > 0) {
          setInitialValues({ active: res.data[0].id });
        }
      },
    }
  );

  const [formatedcustomers, setFormatedcustomers] = useState<{}[]>();
  const { isLoading: loadingcustomers } = useQuery(
    "customers",
    getCustomersDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedcustomers(
          res.data.map((customer: any) => {
            return { value: customer.id, label: customer.name };
          })
        );
      },
    }
  );

  const { isLoading: isSalesLoading } = useMutation(
    "getSales",
    (customerId: number) => getSalesDropdown(customerId),
    {
      onSuccess: (result) => {
        setFormatedSales(
          result?.data.data.map((sale: any) => {
            return { value: sale.id, label: sale.invoiceNo };
          })
        );
      },
    }
  );

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col offset={1} span={20}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("sales")}</>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">{t("receipts-list")}</span>
                ),
              },
            ]}
          />
        </Col>

        <Col offset={1} span={22}>
          <Title title={`${t("receipts-list")}`} />
        </Col>

        <Col offset={1} span={4}>
          <Select
            key={tableKey}
            value={selectedCustomer}
            size="large"
            style={{ width: "100%" }}
            placeholder={t("select-customer")}
            options={formatedcustomers}
            loading={loadingcustomers}
            onChange={(value) => {
              setSelectedCustomer(value);
            }}
          />
        </Col>

        <Col span={5}>
          <RangePicker
            key={tableKey}
            size="large"
            style={{ width: "100%" }}
            format={"MM/DD/YYYY"}
            onChange={(dates, datesString) => {
              setFrom(datesString[0]);
              setTo(datesString[1]);
            }}
          />
        </Col>

        <Col
          offset={11}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>

          <AddButton
            onClick={() => {
              navigate(`/customerreceipts/create`, {
                state: {
                  formatedCurrency: formatedCurrency,
                  loadingCurrency: loadingCurrency,
                  formatedPaymentMode: formatedPaymentMode,
                  loadingPaymentMode: loadingPaymentMode,
                  isSalesLoading: isSalesLoading,
                  formatedsales: formatedsales,
                },
              });
            }}
          />
        </Col>

        <Col offset={1} span={22}>
          <CustomerPaymentList
            payments={payments}
            isPaymentsLoading={isPaymentsLoading}
            getCustomerPaymentsMutation={getCustomerPaymentsMutation}
            selectedCustomer={selectedCustomer}
            setPayments={setPayments}
            setPage={setPage}
            page={page}
            tableKey={tableKey}
          />
        </Col>
      </Row>
    </>
  );
}

export default CustomerPayment;
